




































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Manual extends Vue {
	@Prop()
	private data!: any

	@Prop()
	private modifyingSec!: number

	@Prop()
	private visibleTips!: boolean

	@Prop()
	private notPreview!: boolean

	@Prop()
	private isH5!: boolean

	private get contactInfo(): any {
		return this.data.cover && this.data.cover.contactInfo
	}

	private get desc(): any {
		return this.data.cover && this.data.cover.desc
	}

	private get contentList(): any {
		return this.data.contentList
	}

	private get qrImage(): any {
		return this.data.imageList && this.data.imageList[0]
	}

	private disableToggle(type: string) {
		this.$emit('disableToggle', type)
	}

	private modifyStuff(
		type: string,
		contentIndex: number = -1,
		itemIndex: number = -1
	) {
		this.$emit('modifyStuff', {
			type,
			contentIndex,
			itemIndex,
		})
	}

	private addStuff(
		type: string,
		contentIndex: number = -1,
		itemIndex: number = -1
	) {
		this.$emit('addStuff', {
			type,
			contentIndex,
			itemIndex,
		})
	}

	private removeStuff(
		type: string,
		contentIndex: number = -1,
		itemIndex: number = -1
	) {
		this.$emit('removeStuff', {
			type,
			contentIndex,
			itemIndex,
		})
	}

	private modifyImageDesc(e: any) {
		this.$emit('modifyImageDesc', e.target.value)
	}
}
